<template>
  <span>{{ label }}</span>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

interface IRecord {
  provinceName?: string;
  cityName?: string;
  districtName?: string;
  address?:string;
}

export default defineComponent({
  isGlobal: true,
  name: "LocationDescription",
  props: {
    record: {
      type: Object as PropType<IRecord>,
      default: {
        provinceName: "",
        cityName: "",
        districtName: "",
        address:''
      },
    },
  },
  setup(props) {
    const label = computed(() => {
      let address = props?.record?.address
      if(!address){
        address = ''
      }
      // // console.log('location',props.record,props.record.address)
      return [props?.record?.provinceName, props?.record?.cityName, props?.record?.districtName]
        .filter(Boolean)
        .join("-") ;
        // .join("-")+'  '+address;//  修改bug，详细地址重复出现在所在地区的位置
    });
    return {
      label,
    };
  },
});
</script>
